/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Search icon (Product Toolkit — controls/search, 18×18)
 *
 * @file SearchIcon.jsx
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const SearchIcon = props => (
  <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M7 0C10.866 0 14 3.13401 14 7C14 8.60125 13.4622 10.0774 12.5576 11.2568L15.7305 14.4287C16.0898 14.7881 16.0898 15.3711 15.7305 15.7305C15.3711 16.0898 14.7881 16.0898 14.4287 15.7305L11.2568 12.5576C10.0774 13.4622 8.60125 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7 1.84961C4.15573 1.84961 1.84961 4.15573 1.84961 7C1.84961 9.84427 4.15573 12.1504 7 12.1504C9.84427 12.1504 12.1504 9.84427 12.1504 7C12.1504 4.15573 9.84427 1.84961 7 1.84961Z" fill="#2E2E2E" />
  </SvgIcon>
);

export default SearchIcon;
